export default __webpack_public_path__ + "static/media/basket.23af134a.svg";